import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import type CohoService from 'garaje/services/coho';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type MetricsService from 'garaje/services/metrics';
import type SigmaUrlService from 'garaje/services/sigma-url';
import type StateService from 'garaje/services/state';
import type StatsigService from 'garaje/services/statsig';
import type UserFeatureFlagsService from 'garaje/services/user-feature-flags';
import { APP, WorkplaceEventNames } from 'garaje/utils/enums';
import urlBuilder from 'garaje/utils/url-builder';

export default class AnalyticsDesksController extends Controller {
  @service declare flashMessages: FlashMessagesService;
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare userFeatureFlags: UserFeatureFlagsService;
  @service declare metrics: MetricsService;
  @service declare sigmaUrl: SigmaUrlService;
  @service declare coho: CohoService;
  @service declare statsig: StatsigService;

  @action
  trackUpgradeDesksPlan(): void {
    this.metrics.trackEvent('Clicked a button to upgrade plan from hazed analytics modal');
  }

  get hasAccessToDesksAnalytics(): boolean {
    return !!this.state.features?.canAccessDesksAnalytics;
  }

  get legacyIframeUrl(): string {
    const companyId = this.state?.currentCompany?.id;
    const locationId = this.state?.currentLocation?.id;

    return urlBuilder.embeddedDesksLocationAnalyticsUrl(companyId, locationId);
  }

  @action
  logViewToCohoAndStatsig(): void {
    this.coho.sendEvent(WorkplaceEventNames.VIEW_ANALYTICS_DASHBOARD, { product: APP.WORKPLACE });
    this.statsig.logEvent(`coho_${WorkplaceEventNames.VIEW_ANALYTICS_DASHBOARD}`, null, {
      product: APP.WORKPLACE,
      location_id: this.state?.currentLocation?.id,
    });
  }

  fetchSigmaUrlTask = task({ drop: true }, async () => {
    await this.state.initializeState.last;
    const {
      currentCompany: { id: companyId },
      currentLocation: { id: locationId },
    } = this.state;
    try {
      const result = await this.sigmaUrl.getLocationSigmaUrl(companyId, locationId, 'desks');
      return result;
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', 'Error loading dashboard');
      // eslint-disable-next-line no-console
      console.error(e);
      return;
    }
  });

  get sigmaIframeUrl(): string | null | undefined {
    return this.fetchSigmaUrlTask.last?.value;
  }
}
